import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDrop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6673 11.3333C10.2991 11.3333 10.0007 11.6318 10.0007 12C10.0007 12.3681 10.2991 12.6666 10.6673 12.6666C11.0355 12.6666 11.334 12.3681 11.334 12C11.334 11.6318 11.0355 11.3333 10.6673 11.3333Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99935 11.3333C5.63116 11.3333 5.33268 11.6318 5.33268 12C5.33268 12.3681 5.63116 12.6666 5.99935 12.6666C6.36754 12.6666 6.66602 12.3681 6.66602 12C6.66602 11.6318 6.36754 11.3333 5.99935 11.3333Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6673 7.33329C10.2991 7.33329 10.0007 7.63177 10.0007 7.99996C10.0007 8.36815 10.2991 8.66663 10.6673 8.66663C11.0355 8.66663 11.334 8.36815 11.334 7.99996C11.334 7.63177 11.0355 7.33329 10.6673 7.33329Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6673 3.33329C10.2991 3.33329 10.0007 3.63177 10.0007 3.99996C10.0007 4.36815 10.2991 4.66663 10.6673 4.66663C11.0355 4.66663 11.334 4.36815 11.334 3.99996C11.334 3.63177 11.0355 3.33329 10.6673 3.33329Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99935 7.33329C5.63116 7.33329 5.33268 7.63177 5.33268 7.99996C5.33268 8.36815 5.63116 8.66663 5.99935 8.66663C6.36754 8.66663 6.66602 8.36815 6.66602 7.99996C6.66602 7.63177 6.36754 7.33329 5.99935 7.33329Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99935 3.33329C5.63116 3.33329 5.33268 3.63177 5.33268 3.99996C5.33268 4.36815 5.63116 4.66663 5.99935 4.66663C6.36754 4.66663 6.66602 4.36815 6.66602 3.99996C6.66602 3.63177 6.36754 3.33329 5.99935 3.33329Z",
			fill: "#767676",
			stroke: "#767676",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgDragDrop;
